export default {
  STORE_SERVICE(state, service) {
    state.service = service
  },

  OPEN_TICKET_QUICK_VIEW(state, ticketId) {
    state.ticketQuickViewId = ticketId
  },

  CLOSE_TICKET_QUICK_VIEW(state) {
    state.ticketQuickViewId = null
  }
}
